<div [style.width]="width" class="msf-multi-select-wrapper">
  <div class="msf-multi-select-trigger" (click)="toggleDropdown()" [class.disabled]="disabled">
    <div class="msf-multi-select-label">
      <span *ngIf="!model || model.length === 0" class="placeholder">{{ placeholder }}</span>
      <span *ngIf="model && model.length > 0 && model.length <= maxSelectedLabels" class="selected-items">
        <span *ngFor="let item of getSelectedItems(); let i = index">
          {{ item[optionLabel] }}<span *ngIf="i < getSelectedItems().length - 1">, </span>
        </span>
      </span>
      <span *ngIf="model && model.length > maxSelectedLabels" class="selected-items">
        {{ getSelectedItemsLabel() }}
      </span>
    </div>
    <div class="msf-multi-select-actions">
      <i *ngIf="showClear && model && model.length > 0" class="pi pi-times clear-icon" (click)="clearSelection($event)"></i>
      <i class="pi" [class.pi-chevron-down]="!isDropdownOpen" [class.pi-chevron-up]="isDropdownOpen"></i>
    </div>
  </div>

  <div *ngIf="isDropdownOpen" class="msf-multi-select-panel" [class]="panelStyleClass">
    <div class="msf-multi-select-header" *ngIf="filter">
      <input
        type="text"
        class="msf-multi-select-filter"
        [(ngModel)]="filterValue"
        (input)="onFilterChange()"
        [placeholder]="filterPlaceholder"
      />
    </div>

    <div class="msf-multi-select-items" *ngIf="!loading">
      <div
        *ngFor="let option of filteredOptions"
        class="msf-multi-select-item"
        [class.selected]="option._selected"
        [class.disabled]="isOptionDisabled(option)"
        (click)="!isOptionDisabled(option) && toggleOption(option)"
      >
        <app-checkbox
          [(ngModel)]="option._selected"
          [disabled]="disabled || isOptionDisabled(option)"
          [label]="option[optionLabel]"
          size="medium"
          color="success"
        ></app-checkbox>
      </div>
      <div *ngIf="filteredOptions.length === 0" class="msf-multi-select-empty">
        Aucun résultat
      </div>
    </div>

    <div class="msf-multi-select-loading" *ngIf="loading">
      <i class="pi pi-spinner pi-spin"></i>
      <span>Chargement...</span>
    </div>
  </div>
</div>
